import { showQuestions } from "../renders/show_questions";

export const speakerArray = [];
export let queryArray = [];

const getApiBase = () => {
  // If we're inside /admin, API is one level up: ../api/...
  if (typeof window !== "undefined" && window.location && window.location.pathname) {
    return window.location.pathname.includes("/admin/") ? "../api" : "api";
  }
  return "api";
};

export const show_query_form = () => {
  setTimeout(() => {
    let showFooter = document.getElementById("showFooter");
    let invitationForm = document.getElementById("invitationForm");

    document.getElementById("success").setAttribute("style", "display: none");
    document
        .getElementById("queryContainer")
        .setAttribute("style", "display: none");
    document
        .getElementById("queryFormContainer")
        .setAttribute("style", "display: block");

    if (typeof showFooter !== "undefined" && showFooter !== null) {
      showFooter.setAttribute("style", "display: none");
    }
    if (typeof invitationForm !== "undefined" && invitationForm !== null) {
      invitationForm.setAttribute("style", "display: none");
    }
  }, 300);
};

export const select_speaker = (e) => {
  e.preventDefault();
  let speaker_id = e.target.getAttribute("data-id");
  let activeContainer = document.getElementById(`${speaker_id}`);
  let btn = document.querySelector(`input[data-id='${speaker_id}']`);
  btn.checked = true;
  let speaker = speaker_id;
  let qns = [],
    index;

  //set active, not active classes
  activeContainer.classList.remove("deSelect");
  activeContainer.classList.add("active");

  ///////////////////////////////////////
  // FILTERS AND INDEXES              //
  //////////////////////////////////////
  //filter array to match question clicked
  qns = speakerArray.filter((qn) => qn === speaker);

  //get objectIndex and replace value of question answer
  index = speakerArray.findIndex((item) => item === speaker);

  //question has been answered. check if answer changed.
  if (speakerArray.length > 0) {
    if (qns.length == 0) {
      speakerArray.push(speaker);
    } else {
      //question has already been answered. Replace answer with current selected answer
      if (index !== -1) {
        //speakerArray[index].speaker= name;
        speakerArray.splice(index, 1);
        activeContainer.classList.remove("active");
        activeContainer.classList.add("deSelect");
      } else {
        //cannot find answered question. lets create one.

        activeContainer.classList.remove("deSelect");
        activeContainer.classList.add("active");
        speakerArray.push(speaker);
      }
    }
    //question not answered. create new
  } else {
    speakerArray.push(speaker);
  }
};

export const getQuery = () => {
  const apiBase = getApiBase();
  return fetch(`${apiBase}/query/get_query.php`)
      .then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        return response.json();
      })
      .then((res) => {
        queryArray = Array.isArray(res.data) ? res.data : [];
        showQuestions();
        return queryArray;
      })
      .catch((error) => {
        console.error("🔥 Failed to get query:", error);
        alert("Failed to load queries. Please try again later.");
        throw error;
      });
};


export const HandleQuestions = (questions) => {
  let status = 0;
  questionsArray = questions;

  HandleQueryTabs(questions, status);
};

export const ToggleQueryTab = (e) => {
  e.preventDefault();
  let status;
  let showThis = e.target.getAttribute("data-target");
  let navTabs = document.querySelectorAll(".queryQuestions");
  navTabs.forEach((tab) => tab.classList.remove("active"));
  e.target.classList.add("active");
  let questionsContainer = document.querySelectorAll(".questionsContainer");

  questionsContainer.forEach((container) => {
    container.classList.remove("showThisContainer");
    container.setAttribute("style", "display: none");
  });

  document.getElementById(`${showThis}`).classList.add("showThisContainer");
  if (showThis == "notAnswered") {
    status = 0;
  } else {
    status = 1;
  }
  // HandleQueryTabs(questionsArray, status);
};

export const HandleQueryTabs = (questions, status) => {
  let data = questions.filter((response) => response.answered == status);
  let paginator = "showQuerypagination";
  let showContainer;

  if (status == 1) {
    showContainer = "answered";
  } else {
    showContainer = "notAnswered";
  }

  let listsPerPage = 2;
  let pages = {
    firstPage: "firstQueryPage",
    nextPage: "nextQueryPage",
    previousPage: "previousQueryPage",
    lastPage: "lastQueryPage",
  };

  setTimeout(() => {
    HandlePagination({
      data,
      listsPerPage,
      pages,
      pageContainer: showContainer,
      paginator,
    });
  }, 400);
};

export const updateQuestionStatus = (data) => {
  let { id, status, statusName } = data;
  let findQuestion = findQuestionInArray(queryArray, id);

  if (statusName == "markAnswered" || statusName == "markNotAnswered") {
    findQuestion[0].answered = status;
  }
  if (statusName == "pushQuestion") {
    findQuestion[0].push_question = status;
  }

  return queryArray;
};

const findQuestionInArray = (array, question_id) => {
  return array.filter((item) => item.question_id == question_id);
};
